import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { PricingProfileList } from 'pricing/components';
import { PricingProfilePricingType } from 'pricing/enums';

export const PricingProfileListPage = () => {
  const { t } = useTranslation();

  const title = t('titlePricingProfiles');

  return (
    <PageLayout title={title}>
      <SelectionCountProvider>
        <PageTitle title={title} />

        <PricingProfileList type={PricingProfilePricingType.PRICING} />
      </SelectionCountProvider>
    </PageLayout>
  );
};
